<template>
    <div class="super-filter">
        <div class="top flex-row items-center flex-between">
            <div class="title" v-html="$translate('FILTER')" />
            <i class="zmdi zmdi-close" @click="closeFilter" />
        </div>
        <div class="section-filters" :class="{ 'flex-row': !$store.getters.isMobile }">
            <div class="section-prior-filters flex-fill">
                <div class="slider filter-item" :key="key" v-for="key in ['age', 'height']">
                    <div class="header flex-row items-center flex-between">
                        <div class="title flex-wrap m-r-16" v-html="$translate(key.toUpperCase())" />
                        <div>
                            <span class="range flex-wrap" v-html="$translate(rangeStr(key))" />
                            <span class="unit" v-if="rangeStr(key) !== 'ALL'" v-html="key === 'age' ? '세' : 'cm'" />
                        </div>
                    </div>
                    <VueSlider v-if="key === 'age'" v-model="ageValue" v-bind="sliderOptions(key)" />
                    <VueSlider v-if="key === 'height'" v-model="heightValue" v-bind="sliderOptions(key)" />
                    <div class="min-max flex-row flex-between">
                        <span>{{ sliderOptions(key).min }}</span>
                        <span>{{ sliderOptions(key).max }}</span>
                    </div>
                </div>
                <div class="hr" />
                <!-- 집으로부터의 거리 -->
                <div v-if="filters.searchByDistance" class="slider filter-item">
                    <div class="header flex-row items-center flex-between">
                        <div class="title flex-wrap m-r-16" v-html="$translate('HOUSE_DISTANCE')" />
                        <div>
                            <span class="range flex-wrap" v-html="$translate(rangeStr('houseDistance'))" />
                            <span class="unit" v-html="houseDistanceValue === 50 ? 'km' : 'km 이내'" />
                        </div>
                    </div>
                    <VueSlider v-model="houseDistanceValue" v-bind="sliderOptions('houseDistance')" />
                    <div class="min-max flex-row flex-between">
                        <span>0</span>
                        <span>50+km</span>
                    </div>
                </div>
                <!-- <div v-if="!filters.searchByDistance" class="flex-fill">
                    <FilterItem
                        @onChange="onFilterItem('province', $event)"
                        :title="$case.toSnake('province').toUpperCase()"
                        :items="filters['province']"
                    />
                </div> -->
                <!-- <div class="filter-switch-wrapper flex-row cursor-pointer">
                    <img class="m-r-8 flex-wrap" src="@/assets/images/filter_switch.svg" />
                    <button
                        class="filter-switch-button flex-wrap cursor-pointer f-medium"
                        @click="filters.searchByDistance = !filters.searchByDistance"
                    >
                        {{ searchDistanceString }}로 검색하기
                    </button>
                </div> -->
                <!-- 직장으로부터의 거리 -->
                <div v-if="filters.searchByDistance" class="slider filter-item m-t-40">
                    <div class="header flex-row items-center flex-between">
                        <div class="title flex-wrap m-r-16" v-html="$translate('JOB_DISTANCE')" />
                        <div>
                            <span class="range flex-wrap" v-html="$translate(rangeStr('jobDistance'))" />
                            <span class="unit" v-html="jobDistanceValue === 50 ? 'km' : 'km 이내'" />
                        </div>
                    </div>
                    <VueSlider v-model="jobDistanceValue" v-bind="sliderOptions('jobDistance')" />
                    <div class="min-max flex-row flex-between">
                        <span>0</span>
                        <span>50+km</span>
                    </div>
                </div>
                <!-- <div v-if="!filters.searchByDistance" class="flex-fill">
                    <FilterItem
                        @onChange="onFilterItem('province', $event)"
                        :title="$case.toSnake('province').toUpperCase()"
                        :items="filters['province']"
                    />
                </div> -->
                <!-- <div class="filter-switch-wrapper flex-row cursor-pointer">
                    <img class="m-r-8 flex-wrap" src="@/assets/images/filter_switch.svg" />
                    <button
                        class="filter-switch-button flex-wrap cursor-pointer f-medium"
                        @click="filters.searchByDistance = !filters.searchByDistance"
                    >
                        {{ searchDistanceString }}로 검색하기
                    </button>
                </div> -->
                <!-- <div class="hr" /> -->
                <!-- <div class="filter-important">
                    <div class="filter-important">
                        <FilterItem
                            @onChange="onFilterItem(filterKey, $event)"
                            :title="$case.toSnake(filterKey).toUpperCase()"
                            :items="filters[filterKey]"
                            :key="filterKey"
                            :hideAll="true"
                            :preventMultiSelect="['suggestinoMethodType', 'priority'].indexOf(filterKey) !== -1"
                            v-for="filterKey in importantFilterKeys"
                        />
                    </div>
                </div> -->
                <div class="hr" />
                <div class="filter-financial">
                    <div class="filter-financial">
                        <FilterItem
                            @onChange="onFilterItem(filterKey, $event)"
                            :title="$case.toSnake(filterKey).toUpperCase()"
                            :items="filters[filterKey]"
                            :key="filterKey"
                            :hideAll="true"
                            v-for="filterKey in financialFilterKeys"
                        />
                    </div>
                </div>
                <div class="hr" />
                <!-- <div class="filter-priorities">
                    <div class="filter-priorities">
                        <FilterItem
                            @onChange="onFilterItem(filterKey, $event)"
                            :title="$case.toSnake(filterKey).toUpperCase()"
                            :items="filters[filterKey]"
                            :hideAll="['neverIntroduced', 'lastSign'].indexOf(filterKey) !== -1"
                            :preventMultiSelect="['lastSign'].indexOf(filterKey) !== -1"
                            :user="['neverIntroduced'].indexOf(filterKey) !== -1 ? chat.user : {}"
                            :key="filterKey"
                            v-for="filterKey in rightFirstFilterKeys"
                        />
                    </div>
                </div> -->
                <div class="filter-priorities">
                    <div class="filter-priorities">
                        <FilterItem
                            @onChange="onFilterItem(filterKey, $event)"
                            :title="$case.toSnake(filterKey).toUpperCase()"
                            :items="filters[filterKey]"
                            :hideAll="['neverIntroduced', 'lastSign'].indexOf(filterKey) !== -1"
                            :preventMultiSelect="['lastSign'].indexOf(filterKey) !== -1"
                            :user="['neverIntroduced'].indexOf(filterKey) !== -1 ? chat.user : {}"
                            :key="filterKey"
                            v-for="filterKey in rightFirstFilterKeys"
                        />
                    </div>
                </div>
                <div class="hr" />
                <div class="filter-spec">
                    <div class="filter-spec">
                        <FilterItem
                            @onChange="onFilterItem(filterKey, $event)"
                            :title="$case.toSnake(filterKey).toUpperCase()"
                            :items="filters[filterKey]"
                            :key="filterKey"
                            v-for="filterKey in specFilterKeys"
                        />
                    </div>
                </div>
                <!-- <div class="hr" /> -->
                <!-- <div class="filter-profiles" :key="filterKey" v-for="filterKey in kindShapeFilterKeys">
                    <FilterItem
                        @onChange="onFilterItem(filterKey, $event)"
                        :title="$case.toSnake(filterKey).toUpperCase()"
                        :items="filters[filterKey]"
                    />
                </div> -->

                <!-- <div class="hr" /> -->
            </div>
            <div class="section-prior-filters flex-fill">
                <!-- <div class="filter-priorities">
                    <FilterItem
                        @onChange="onFilterItem(filterKey, $event)"
                        :title="$case.toSnake(filterKey).toUpperCase()"
                        :items="filters[filterKey]"
                        :hideAll="['neverIntroduced', 'lastSign'].indexOf(filterKey) !== -1"
                        :preventMultiSelect="['lastSign'].indexOf(filterKey) !== -1"
                        :user="['neverIntroduced'].indexOf(filterKey) !== -1 ? chat.user : {}"
                        :key="filterKey"
                        v-for="filterKey in rightFirstFilterKeys"
                    />
                </div>
                <div class="hr" /> -->
                <FilterItem
                    @onChange="onFilterItem(filterKey, $event)"
                    :title="$case.toSnake(filterKey).toUpperCase()"
                    :items="filters[filterKey]"
                    :key="filterKey"
                    v-for="filterKey in leftFirstFilterKeys"
                />
                <div class="hr" />

                <div class="flex-fill" :key="filterKey" v-for="filterKey in detailedFilterKeys.slice(0, 1)">
                    <FilterItem
                        @onChange="onFilterItem(filterKey, $event)"
                        :title="$case.toSnake(filterKey).toUpperCase()"
                        :items="filters[filterKey]"
                    />
                </div>

                <!-- 수락률 -->
                <div class="slider filter-item" :key="key" v-for="key in ['acceptRate']">
                    <div class="header flex-row items-center flex-between">
                        <div class="title flex-wrap m-r-16" v-html="$translate(key.toUpperCase())" />
                        <div>
                            <span class="range flex-wrap" v-html="$translate(rangeStr(key))" />
                            <span class="unit" v-if="rangeStr(key) !== 'ALL'" v-html="'%'" />
                        </div>
                    </div>
                    <VueSlider v-if="key === 'acceptRate'" v-model="acceptRateValue" v-bind="sliderOptions(key)" />
                    <div class="min-max flex-row flex-between">
                        <span>{{ sliderOptions(key).min }}</span>
                        <span>{{ sliderOptions(key).max }}</span>
                    </div>
                </div>
                <!-- 피수락률 -->
                <div class="slider filter-item" :key="key" v-for="key in ['acceptedRate']">
                    <div class="header flex-row items-center flex-between">
                        <div class="title flex-wrap m-r-16" v-html="$translate(key.toUpperCase())" />
                        <div>
                            <span class="range flex-wrap" v-html="$translate(rangeStr(key))" />
                            <span class="unit" v-if="rangeStr(key) !== 'ALL'" v-html="'%'" />
                        </div>
                    </div>
                    <VueSlider v-if="key === 'acceptedRate'" v-model="acceptedRateValue" v-bind="sliderOptions(key)" />
                    <div class="min-max flex-row flex-between">
                        <span>{{ sliderOptions(key).min }}</span>
                        <span>{{ sliderOptions(key).max }}</span>
                    </div>
                </div>

                <div class="flex-fill" :key="filterKey" v-for="filterKey in detailedFilterKeys.slice(1, 3)">
                    <FilterItem
                        @onChange="onFilterItem(filterKey, $event)"
                        :title="$case.toSnake(filterKey).toUpperCase()"
                        :items="filters[filterKey]"
                    />
                </div>

                <!-- <div class="filter-belongings" :key="filterKey" v-for="filterKey in belongingFilterKeys">
                    <FilterItem
                        @onChange="onFilterItem(filterKey, $event)"
                        :title="$case.toSnake(filterKey).toUpperCase()"
                        :items="filters[filterKey]"
                    />
                </div> -->
                <div class="hr" />
                <div class="filter-review">
                    <FilterItem
                        @onChange="onFilterItem('meetingReviewType', $event)"
                        :title="$case.toSnake('meetingReviewType').toUpperCase()"
                        :items="filters.meetingReviewType"
                    />
                    <FilterItem
                        @onChange="onFilterItem('reviewKeywordType', $event)"
                        :title="$case.toSnake('reviewKeywordType').toUpperCase()"
                        :items="reviewKeywordItems"
                    />
                </div>
            </div>
        </div>
        <div class="bottom-button-wrapper">
            <button class="bottom-button" @click="superSearch">검색</button>
        </div>
    </div>
</template>

<script>
import FilterItem from '@/components/common/FilterItem'
import * as helpers from '@/store/data/helpers'

export default {
    name: 'SuperFilter',
    props: ['filters', 'filterChanged'],
    data: () => ({
        titleFocused: false,
        filters: {
            meetingReviewType: [],
            reviewKeywordType: [],
        },
    }),
    components: { FilterItem },
    mounted() {
        this.$set(this.chat, '$$filtersTemp', this.$copy(this.filters))
    },
    watch: {
        filters: {
            handler() {
                if (!this.chat.$$filtersTemp) return

                const changed =
                    Object.keys(this.chat.$$filters).filter(key => {
                        if (Array.isArray(this.chat.$$filters[key])) {
                            return (
                                this.chat.$$filters[key].filter(
                                    (p, idx) => p.selected !== this.chat.$$filtersTemp[key][idx].selected
                                ).length > 0
                            )
                        } else {
                            return this.chat.$$filters[key] !== this.chat.$$filtersTemp[key]
                        }
                    }).length > 0
                if (changed) {
                    helpers.updateFiltersInLocalStorage(this.$store.getters.chats)
                    this.$emit('update:filterChanged', true)
                } else {
                    this.$emit('update:filterChanged', false)
                }
            },
            deep: true,
        },
        chat: {
            handler() {
                this.$set(this.chat, '$$filtersTemp', this.$copy(this.filters))
            },
        },
    },
    computed: {
        searchDistanceString() {
            return this.filters.searchByDistance ? '지역으' : '거리'
        },
        ageValue: {
            get() {
                return [this.filters.minAge, this.filters.maxAge]
            },
            set(newVal) {
                this.filters.minAge = newVal[0]
                this.filters.maxAge = newVal[1]
            },
        },
        heightValue: {
            get() {
                return [this.filters.minHeight, this.filters.maxHeight]
            },
            set(newVal) {
                this.filters.minHeight = newVal[0]
                this.filters.maxHeight = newVal[1]
            },
        },
        // targetHeightValue: {
        //     get() {
        //         return [this.filters.minTargetHeight, this.filters.maxTargetHeight]
        //     },
        //     set(newVal) {
        //         this.filters.minTargetHeight = newVal[0]
        //         this.filters.maxTargetHeight = newVal[1]
        //     },
        // },
        houseDistanceValue: {
            get() {
                return this.filters.houseDistance
            },
            set(newVal) {
                this.filters.houseDistance = newVal
            },
        },
        jobDistanceValue: {
            get() {
                return this.filters.jobDistance
            },
            set(newVal) {
                this.filters.jobDistance = newVal
            },
        },

        acceptRateValue: {
            get() {
                return [this.filters.minAcceptRate, this.filters.maxAcceptRate]
            },
            set(newVal) {
                this.filters.minAcceptRate = newVal[0]
                this.filters.maxAcceptRate = newVal[1]
            },
        },
        acceptedRateValue: {
            get() {
                return [this.filters.minAcceptedRate, this.filters.maxAcceptedRate]
            },
            set(newVal) {
                this.filters.minAcceptedRate = newVal[0]
                this.filters.maxAcceptedRate = newVal[1]
            },
        },
        defaultParams() {
            return {
                minAge: 20,
                maxAge: 49,
                minHeight: 140,
                maxHeight: 199,
                // minTargetHeight: 140,
                // maxTargetHeight: 199,
                houseDistance: 50,
                jobDistance: 50,
                // smoking: [
                //     {
                //         name: '흡연',
                //         value: true,
                //         selected: true,
                //     },
                //     {
                //         name: '비흡연',
                //         value: false,
                //         selected: true,
                //     },
                // ],
            }
        },
        detailedFilterKeys() {
            return ['jobDetailType', 'marryType', 'marryPlanType']
            // return ['isStudent', 'jobDetailType', 'schoolType']
        },
        reviewKeywordItems() {
            return this.chat.user.gender === 0 ? this.filters.reviewKeywordType_m : this.filters.reviewKeywordType_f
        },
        importantFilterKeys() {
            // const arr = ['suggestionMethodType', 'priority', 'appearanceRate']
            const arr = ['suggestionMethodType', 'priority', 'forceType']
            return arr
        },
        financialFilterKeys() {
            const arr = ['income', 'asset']
            return arr
        },
        specFilterKeys() {
            const arr = ['specGradeType', 'lookGradeType', 'totalGradeType']
            return arr
        },
        leftFirstFilterKeys() {
            const arr = ['religion', 'schoolType']
            return arr
        },
        rightFirstFilterKeys() {
            // const arr = ['appearanceRate', 'lastSign', 'neverIntroduced', 'preferences', 'no_ons_campaign']
            // const arr = ['lastSign', 'neverIntroduced']
            const arr = ['neverIntroduced']
            return arr
        },
        kindShapeFilterKeys() {
            // const arr = ['shape', 'kind', 'mbti']
            const arr = ['mbti']
            return arr
        },
        // belongingFilterKeys() {
        //     const arr = ['car', 'pet']
        //     return arr
        // },
        styleFilterKeys() {
            const arr = ['targetFriendType', 'targetSpecType', 'targetSmokingType']
            return arr
        },
        chat() {
            return this.$store.getters.chat || {}
        },
        agent() {
            return this.$store.getters.agent || {}
        },
        isPremium() {
            return this.agent ? this.agent.is_premium : false
        },
    },
    methods: {
        rangeStr(type) {
            if (type === 'houseDistance') {
                const val = this.houseDistanceValue
                if (val === 50) return `${this.houseDistanceValue}+`
                else return this.houseDistanceValue
            } else if (type === 'jobDistance') {
                const val = this.jobDistanceValue
                if (val === 50) return `${this.jobDistanceValue}+`
                else return this.jobDistanceValue
            } else {
                const min = this[`${type}Value`][0]
                const max = this[`${type}Value`][1]
                if (min === this.sliderOptions(type).min && max === this.sliderOptions(type).max) return 'ALL'

                return `${min} ~ ${max}`
            }
        },
        sliderOptions(type) {
            if (type === 'distance' || type === 'houseDistance' || type === 'jobDistance') {
                return {
                    min: 0,
                    max: 50,
                    tooltip: 'none',
                }
            } else if (type === 'acceptRate') {
                return {
                    min: 0,
                    max: 40,
                    tooltip: 'none',
                }
            } else if (type === 'acceptedRate') {
                return {
                    min: 0,
                    max: 40,
                    tooltip: 'none',
                }
            } else {
                return {
                    min: this.defaultParams[`min${this.$case.toCapital(type)}`],
                    max: this.defaultParams[`max${this.$case.toCapital(type)}`],
                    tooltip: 'none',
                }
            }
        },
        closeFilter() {
            this.$store.commit('setShowFriendsFilter', false)
            this.$emit('update:filterChanged', false)
        },
        onFilterItem(filterKey, filter) {
            if (!filterKey || !filter) return

            if (filterKey === 'preferences' && filter.item) {
                this.toggleAutoFilter(filter.item.value)
            }

            this.filters[filterKey] = this.$copy(filter.items)
        },
        toggleAutoFilter(on) {
            if (on) {
                helpers.setAgeHeightFiltersByStyles(this.chat, this.filters)
            } else {
                Object.keys(this.defaultParams).forEach(key => {
                    this.filters[key] = this.$copy(this.defaultParams[key])
                })
            }
        },
        superSearch() {
            this.$bus.$emit('setFriendScrollTop')
            this.$store.commit('setRecommendsFromDB', [])
            // this.filters.type = null

            // meetingReviewType, reviewKeywordType 값 필터에 포함
            console.log('superSearch this.filter', this.filters)
            const filters = {
                ...this.filters,
                meetingReviewType: this.filters.meetingReviewType.length > 0 ? this.filters.meetingReviewType : null,
                reviewKeywordType: this.filters.reviewKeywordType.length > 0 ? this.filters.reviewKeywordType : null,
            }

            this.$set(this.chat, '$$filtersTemp', this.$copy(this.filters))
            this.$hooks.superSearch(filters)
            this.$emit('onClickSuperSearch')
            this.$emit('update:filterChanged', false)
            localStorage.setItem('searchedAI', false)
        },
    },
}
</script>
<style scoped lang="scss">
.super-filter {
    height: 100%;
}
</style>
